import { arraySortAscendingFunction } from '../../../services/utilities/utilities';
import { PROFILE_TYPE } from '../../../constants';

export const actions = {
    async setAvailableSvgFiles({ dispatch, commit }) {
        const result = await dispatch('useApiData', { name: 'PolygonSvgFiles' });
        let availableSvgFiles = [];
        if (result?.data) {
            availableSvgFiles = result.data;
        }
        commit('SET_AVAILABLE_SVG_FILES', availableSvgFiles);
    },
    async getUsageChartData({ dispatch }, { organizationId, filter, type = 'Events', start, end }) {

        // Haal een lijst met themaprofielen op uit de backend.
        async function getThemeProfiles() {

            const profilesResult = await dispatch('useApiData', {
                name: 'GetProfileOverview',
                parameters: { profileTypeId: PROFILE_TYPE.THEME_FEEDBACK }
            });
            if (profilesResult?.data) {
                themeProfiles = [
                    ...profilesResult.data.map((item) => {
                        return { id: item.id, name: item.name };
                    })
                ];

            }

            return themeProfiles;

        }

        function translateProfileIds(profileString) {
            const profilesArray = JSON.parse(profileString); // Convert it from a string to an array

            return profilesArray
                .map(id => {
                    // Find the object where the id matches
                    const mapping = themeProfiles.find(item => item.id === id);
                    return mapping ? mapping.name : ''; // Return the name or an empty string if not found
                })
                .filter(name => name) // Remove any empty strings
                .sort((a, b) => a.localeCompare(b)) // Sort names alphabetically
                .join(', '); // Join names into a comma-separated string

        }
        const findColumnIndex = (cols) => (columnName) => {
            return cols.findIndex(
                ({ name }) => name === columnName
            );
        };
        const datetimeColumnNames = ['timestamp'];
        const parseColumnNames = ['customDimensions', 'customMeasurements'];
        const booleanSubColumnNames = ['isAdmin', 'isSuper', 'usage'];
        const numberSubColumnNames = ['duration', 'organizationId', 'userId'];
        const arraySubColumnNames = ['profiles'];

        const usageStatisticResult = await dispatch('useApiData', {
            name: `GetAnalytics${type}`,
            parameters: { OrganizationId: organizationId },
            data: {
                filter,
                organizationId,
                start: start?.toISOString(),
                end: end?.toISOString()
            },
            useLoader: true
        });
        const data = JSON.parse(usageStatisticResult.data);
        const tableData = data?.tables?.[0];
        const columns = tableData.columns;

        // Find the position of a column named profiles
        const profiles = columns.findIndex(c => c.name === 'profiles');
        let themeProfiles = [];
        if (profiles > 0) {
            themeProfiles = await getThemeProfiles();
        }

        // these columns contain unparsed json data
        // we get the indexes so we can parse the data
        const parseColumnIndexes = parseColumnNames.map(
            findColumnIndex(columns)
        );
        // change the data to usable formats
        tableData.rows.forEach((row) => {
            // use javascript date instead of string
            datetimeColumnNames.forEach(columnName => (
                row[findColumnIndex(columns)(columnName)] && (row[findColumnIndex(columns)(columnName)] = new Date(row[findColumnIndex(columns)(columnName)]))
            ));
            parseColumnIndexes.forEach((index) => {
                if (index < 0) {
                    return;
                }
                const rowData = JSON.parse(row[index]);
                // force the correct datatype for these columns
                if (rowData) {
                    booleanSubColumnNames.forEach(subColumnName => (rowData[subColumnName] && (rowData[subColumnName] = rowData[subColumnName] === 'true')));
                    numberSubColumnNames.forEach(subColumnName => (rowData[subColumnName] && (rowData[subColumnName] = parseInt(rowData[subColumnName]))));
                    arraySubColumnNames.forEach(subColumnName => {
                        try {
                            rowData[subColumnName] && (rowData[subColumnName] = JSON.parse(rowData[subColumnName]));
                        } catch (err) {
                            rowData[subColumnName] && (rowData[subColumnName] = []);
                            console.log(err);
                        }
                    });
                }
                row[index] = rowData;
            });

            // If the data contains a column with the name profiles
            // translate the array of profile Ids into a comma separated string of profile names.
            if (profiles > 0) {
                row[profiles] = translateProfileIds(row[profiles]);
            }
        });
        return data;
    },
    async getOrganizationSetting({ dispatch }, { name }) {
        try {
            const result = await dispatch('useApiData', {
                name: 'GetOrganizationSetting',
                parameters: { Name: name }
            });
            return result.data.value;
        } catch (error) {
            return null;
        }
    },

    // select tables that have a geometry column and the ones that don't
    async getTableNames({ dispatch }) {
        // Get non-geometry tables
        let result = await dispatch('useApiData', {
            name: 'GetTableNames',
            parameters: { geometrytables: false }
        });
        const nonGeoTableNames = result?.data?.map((item) => {
            return { layerName: item };
        });
        // Get geometrytables
        result = await dispatch('useApiData', {
            name: 'GetTableNames',
            parameters: { geometrytables: true }
        });
        const geoTableNames = result?.data?.map((item) => {
            return { layerName: item };
        });
        // return both geometry and non geometry tables
        return nonGeoTableNames.concat(
            geoTableNames
        ).sort(arraySortAscendingFunction('layerName'));
    }
};
